import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'sonner'

import { useCreateData } from '../../hooks/useApi'
import logger from '../../utils/logger'
import GeneratedForm from '../generated-form'

function BusinessFormHomePage() {
  const params = useParams()
  const [formData, setFormData] = useState(null)

  const { mutate } = useCreateData('/getActiveForm', 'forms')

  useEffect(() => {
    mutate(
      { businessId: params.id },
      {
        onSuccess: (responseData) => {
          // Find the form with matching ID if there are multiple forms

          setFormData(responseData?.data?.form[0])
        },
        onError: (err) => {
          logger.error('🔴 Error creating data:', err)
          toast.error('Failed to load form')
        },
      }
    )
  }, [params.id, mutate])

  function stripHtml(html) {
    const div = document.createElement('div')
    div.innerHTML = html
    return div.textContent || div.innerText || ''
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4 sm:px-6 md:px-8 bg-gradient-to-r from-[#F7E5FF] via-[#F7E6FF] via-10% to-[#D6E0FF] to-100% sm:pt-10 md:pt-22 pb-5">
      <div className="w-full md:w-[650px] my-10 p-4 sm:p-6 md:p-6 rounded-3xl bg-white shadow-2xl">
        <div className="w-full space-y-6">
          <div className="text-center">
            {/* Heading */}
            <h1 className="text-2xl md:text-3xl font-bold bg-gradient-to-r text-heading-primary to-blue-600 bg-clip-text">
              {formData?.elements.some((el) => el.type === 'heading') ? (
                formData.elements
                  .filter((el) => el.type === 'heading')
                  .map((el) => <React.Fragment key={el.id}>{stripHtml(el.label)}</React.Fragment>)
              ) : (
                <>Register Form</>
              )}
            </h1>

            {/* Description */}
            <p className="mt-2 text-md text-gray-600">
              {formData?.elements.some((el) => el.type === 'description') ? (
                formData.elements
                  .filter((el) => el.type === 'description')
                  .map((el) => <React.Fragment key={el.id}>{stripHtml(el.label)}</React.Fragment>)
              ) : (
                <>Please fill in the required details below</>
              )}
            </p>
          </div>
          <div className="w-full mx-auto" style={{ maxWidth: '100%' }}>
            <GeneratedForm sharedId={params.id} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default BusinessFormHomePage
